var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mb-15"
  }, [_c('h3', {
    staticClass: "text-28 text-md-20"
  }, [_vm._v("자문단 답변 "), _c('span', {
    staticClass: "color-primary"
  }, [_vm._v(_vm._s(_vm.responses.length))])])]), _c('div', {
    staticClass: "mb-30"
  }, [_c('div', {
    staticClass: "answer-items"
  }, _vm._l(_vm.responses, function (response) {
    return _c('response', {
      key: response._id,
      attrs: {
        "response": response
      },
      model: {
        value: _vm.value,
        callback: function callback($$v) {
          _vm.value = $$v;
        },
        expression: "value"
      }
    });
  }), 1)]), _c('div', [_vm.isRequestee ? _c('div', {
    staticClass: "comment-card"
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('v-textarea', {
    staticClass: "white",
    attrs: {
      "placeholder": "답변을 입력하세요.",
      "light": "",
      "outlined": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: _vm.response.content,
      callback: function callback($$v) {
        _vm.$set(_vm.response, "content", $$v);
      },
      expression: "response.content"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('v-row', {
    staticClass: "row--small ma-n1 ma-md-0 h-100"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12"
    }
  }, [_c('v-file-btn', {
    staticClass: "h-100 h-md-36",
    attrs: {
      "block": "",
      "outlined": "",
      "color": "gray-9"
    },
    on: {
      "input": _vm.pushFile
    }
  }, [_vm._v("첨부")])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12"
    }
  }, [_c('v-btn', {
    staticClass: "h-100 h-md-36",
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("등록")])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "mt-5"
  }, [_vm.response.files.length ? _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "column": ""
    },
    model: {
      value: _vm.response.files,
      callback: function callback($$v) {
        _vm.$set(_vm.response, "files", $$v);
      },
      expression: "response.files"
    }
  }, _vm._l(_vm.response.files, function (file) {
    return _c('v-chip', {
      key: file.name,
      attrs: {
        "outlined": "",
        "value": file
      }
    }, [_vm._v(_vm._s(file.name)), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-close")])], 1);
  }), 1) : _vm._e()], 1)], 1) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }